export default __webpack_public_path__ + "static/media/truck.a6c0edbb.png";